import { createStandardAction } from 'typesafe-actions';
import {
  SET_PRIVATE_BULLETIN_SUCCESFULLY_PROMOTED_MODAL,
  SET_PRIVATE_BULLETIN_SUCCESFULLY_PROMOTED_POPOVER,
  SET_PRIVATE_BULLETIN_HAS_ALREADY_BEEN_PROMOTED_MODAL,
  MANUAL_PROMOTE_PRIVATE_BULLETIN,
  SET_PRIVATE_BULLETIN_SELECT_PROMOTION_PLAN_MODAL,
  SET_PRIVATE_BULLETIN_MINIMUM_PLAN_MODAL,
  SET_PRIVATE_BULLETIN_PLAN_LOADING_MODAL,
  UPGRADE_USER_PLAN_FLOW,
  REDEEM_PROMOTION_PLAN_GRANT,
  SET_REDEEM_PROMOTION_PLAN_GRANT_RESULT_MODAL,
  LOAD_PLANS_DATA,
  CANCEL_USER_PROMOTION_PLAN,
  CANCEL_SUBSCRIPTION_THEN_EDIT_LISTING_STATUS,
  SET_CANCEL_USER_PROMOTION_PLAN_RESULT_MODAL,
} from './types';
import { EditListingStatusParams } from 'store/state/uploadBulletin/actions';
import { BulletinPoiType, DealType } from 'utils/entities';
import { PrivateUserMonetizationSource } from '..';

export const setPrivateBulletinSuccesfullyPromotedModal = createStandardAction(SET_PRIVATE_BULLETIN_SUCCESFULLY_PROMOTED_MODAL)<{ isOpen: boolean; bulletinId?: string | null }>();
export const setPrivateBulletinSuccesfullyPromotedPopover = createStandardAction(SET_PRIVATE_BULLETIN_SUCCESFULLY_PROMOTED_POPOVER)<{ isOpen: boolean; isPaidAndRunning?: boolean; bulletinId?: string | null }>();
export const loadPlansDataAction = createStandardAction(LOAD_PLANS_DATA)();
export const setPrivateBulletinHasAlreadyBeenPromotedModal = createStandardAction(SET_PRIVATE_BULLETIN_HAS_ALREADY_BEEN_PROMOTED_MODAL)<{ isOpen: boolean; bulletinId?: string | null }>();
export const setPrivateBulletinSelectPromotionPlanModal = createStandardAction(SET_PRIVATE_BULLETIN_SELECT_PROMOTION_PLAN_MODAL)<{ isOpen: boolean; isSelectedPaidPlan?: boolean; bulletinId: string | null }>();
export const setPrivateBulletinMinimumPromotionPlanModal = createStandardAction(SET_PRIVATE_BULLETIN_MINIMUM_PLAN_MODAL)<{ isOpen: boolean; bulletin: { id: string } | null }>();
export const setPrivateBulletinPlanLoadingModal = createStandardAction(SET_PRIVATE_BULLETIN_PLAN_LOADING_MODAL)<{ isOpen: boolean }>();

export interface UpgradeUserPlanFlowPayload {
  bulletinId: string | null;
  userInitiated?: boolean;
  source: PrivateUserMonetizationSource;
}

export const upgradeUserPlanFlow = createStandardAction(UPGRADE_USER_PLAN_FLOW)<UpgradeUserPlanFlowPayload>();

export enum PromotePrivateBulletinViewSource {
  ManageBulletinsPage = 'manage_bulletins_page',
  BulletinPage = 'bulletin_page',
}
export interface PromotePrivateBulletinPayload {
  bulletinId: string;
  bulletinType: BulletinPoiType;
  dealType: DealType;
  viewSource: PromotePrivateBulletinViewSource;
  isTimerStillRunning: boolean;
}
export const promotePrivateBulletin = createStandardAction(MANUAL_PROMOTE_PRIVATE_BULLETIN)<PromotePrivateBulletinPayload>();

export interface RedeemPromotionPlanGrantPayload {
  planId: string;
  phone?: string;
}
export const redeemPromotionPlanGrant = createStandardAction(REDEEM_PROMOTION_PLAN_GRANT)<RedeemPromotionPlanGrantPayload>();
export const setRedeemPromotionPlanGrantResultModal = createStandardAction(SET_REDEEM_PROMOTION_PLAN_GRANT_RESULT_MODAL)<{ isOpen: boolean }>();

export interface CancelUserPromotionPlanPayload {
  userPromotionPlanId: string;
  reason?: string;
}
export const cancelUserPromotionPlan = createStandardAction(CANCEL_USER_PROMOTION_PLAN)<CancelUserPromotionPlanPayload>();

export interface CancelSubscriptionThenEditListingStatusPayload {
  userPromotionPlanId: string;
  editListingStatus: EditListingStatusParams;
}
export const cancelSubscriptionThenEditListingStatus = createStandardAction(CANCEL_SUBSCRIPTION_THEN_EDIT_LISTING_STATUS)<CancelSubscriptionThenEditListingStatusPayload>();

export const setCancelUserPromotionPlanResultModal = createStandardAction(SET_CANCEL_USER_PROMOTION_PLAN_RESULT_MODAL)<{ isOpen: boolean }>();
